<!-- eslint-disable vue/html-self-closing -->
<template>
  <section
    v-if="discussions?.length > 0"
    class="issue-discussions"
  >
    <transition-group
      class="issue-discussions__list"
      name="discussions-list"
      tag="div"
    >
      <issue-discussion
        v-for="discussion in discussions"
        :key="discussion.id"
        :discussion="discussion"
      ></issue-discussion>
    </transition-group>
    <pagination
      v-if="page && page.totalPages > 1"
      :pager="page"
      @change="paginate"
    />
  </section>
  <section
    v-else-if="discussions?.length === 0"
    class="issue-discussions"
  >
    <div class="issue-discussions__empty">
      {{ $t('disscussion_none') }}
    </div>
  </section>
</template>

<script>
import IssueMessages from '@shared/modules/issue/issue.messages';
import IssueDiscussion from '@shared/modules/issue/components/item/IssueDiscussion';
import Pagination from '@shared/shared-components/shared/pagination';

export default {
  name: 'IssueDiscussions',
  components: {
    IssueDiscussion,
    Pagination
  },
  computed: {
    discussions() {
      return this.$store.getters.getIssueDiscussions;
    },
    page() {
      return this.$store.getters.getIssueDiscussionsPage;
    }
  },
  methods: {
    paginate(page) {
      this.$router.push({ query: { ...this.$route.query, page } }).catch(() => {});
    }
  },
  i18n: {
    messages: IssueMessages
  }
};
</script>

<style lang="scss">
$this: '.issue-discussions';

#{$this} {
  #{$this}__list {
    display: flex;
    flex-direction: column;
    gap: 24px;

    #{$this}__discussion {
      display: flex;
      flex-direction: column;
      gap: 8px;

      #{$this}__header {
        display: flex;
        align-items: center;
        gap: 4px;

        @include theme.max-md {
          flex-wrap: wrap;
        }

        & > .author {
          display: flex;
          align-items: center;
          gap: 4px;
          flex-wrap: nowrap;
          white-space: nowrap;
          cursor: pointer;

          @include theme.max-md {
            flex-wrap: wrap;
          }

          &:hover {
            & > * {
              color: var(--primary) !important;
            }
          }

          & > .avatar {
            border-radius: 11px;
          }
          & > .fullname {
            max-width: 250px;
            color: var(--text);
            overflow: hidden;
            text-overflow: ellipsis;

            @include theme.max-xxl {
              max-width: 200px;
            }
            @include theme.max-xl {
              max-width: 135px;
            }
            @include theme.max-md {
              max-width: 145px;
            }
            @include theme.max-sm {
              max-width: 260px;
            }
          }
          & > .username {
            max-width: 250px;
            color: var(--text-muted);
            overflow: hidden;
            text-overflow: ellipsis;

            @include theme.max-xxl {
              max-width: 200px;
            }
            @include theme.max-xl {
              max-width: 135px;
            }
            @include theme.max-md {
              max-width: 145px;
            }
            @include theme.max-sm {
              max-width: 280px;
            }
          }
        }
        & > .info {
          color: var(--text-muted);
          white-space: nowrap;
        }
      }

      #{$this}__content {
        display: flex;
        flex-direction: column;
        border: 1px solid var(--border-color);
        border-radius: 6px;
      }
    }
  }

  #{$this}__empty {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--primary);
    border: 1px solid var(--primary);
    border-radius: 6px;
    background-color: color-mix(in srgb, var(--primary) 10%, var(--white));
  }

  .discussions-list-enter-from,
  .discussions-list-leave-to {
    animation: gf-hide-discussion 0.2s ease-in-out;
  }

  .discussion-reply-enter-from,
  .discussion-reply-leave-to {
    animation: gf-hide-discussion 0.25s ease-in-out;
  }

  @keyframes gf-hide-discussion {
    0% {
      max-height: 2000px;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 0;
      max-height: 0;
    }
  }
}
</style>
